var __headerScrollRAF = null;
window.addEventListener("scroll", function () {
  if (__headerScrollRAF) return;
  __headerScrollRAF = requestAnimationFrame(function () {
    __headerScrollRAF = null;
    const siteHeader = document.getElementById("SiteHeader");
    const mobile_search = document.querySelector(
      ".site-header__search-container_mobile"
    );

    if (window.scrollY < 250) {
      siteHeader.classList.remove("site-header--stuck");
      siteHeader.classList.remove("site-header--opening");
      mobile_search.classList.remove("site-header--stuck");
    } else {
      siteHeader.classList.add("site-header--stuck");
      siteHeader.classList.add("site-header--opening");
      mobile_search.classList.add("site-header--stuck");
    }
  });
}, { passive: true });

document.addEventListener("DOMContentLoaded", function () {

  const swatchColorMap = {
    schwarz: "#000000",
    schwarzgrau: "#2b2b2b",
    graugrau: "#808080",
    grau: "#808080",
    anthrazit: "#303030",
    anthrazitgrau: "#303030",
    weiss: "#ffffff",
    weiß: "#ffffff",
    creme: "#f5f5dc",
    beige: "#f5f5dc",
    sand: "#d8c29c",
    braun: "#6b4a2b",
    braungrau: "#6b4a2b",
    grau_meliert: "#8a8a8a",
    "grau-meliert": "#8a8a8a"
  };

  const normalizeSwatchName = (name) =>
    (name || "").toString().toLowerCase().trim();

  const resolveSwatchColor = (name) =>
    swatchColorMap[normalizeSwatchName(name)] || name;

  function restoreSwatchBackgrounds() {
    const swatches = document.querySelectorAll(
      ".color-swatch, .color_swatch_filter"
    );

    swatches.forEach((swatch) => {
      const img = swatch.dataset.swatchImage;
      const color = swatch.dataset.swatchColor;
      const computed = window.getComputedStyle(swatch);
      const missingImage =
        img &&
        (computed.backgroundImage === "none" ||
          computed.backgroundImage === 'url("")');

      if (missingImage) {
        swatch.style.backgroundImage = `url(${img})`;
      }

      const missingColor =
        color &&
        (computed.backgroundColor === "rgba(0, 0, 0, 0)" ||
          computed.backgroundColor === "transparent");

      if (missingColor) {
        swatch.style.backgroundColor = resolveSwatchColor(color);
      }
    });
  }

  const scheduleSwatchRestore = () => {
    restoreSwatchBackgrounds();
    setTimeout(restoreSwatchBackgrounds, 500);
  };

  scheduleSwatchRestore();
  document.addEventListener("page:loaded", scheduleSwatchRestore);
  document.addEventListener("shopify:section:load", scheduleSwatchRestore);

  document.querySelectorAll(".product__quantity").forEach((quantityElement) => {
    const section = quantityElement.closest(".product-section") || document;
    const purchaseRow = section.querySelector(".product-form__purchase-row");
    if (purchaseRow && !purchaseRow.contains(quantityElement)) {
      purchaseRow.appendChild(quantityElement);
    }
  });

  // const quantityElement = document.querySelector(
  //   ".product-block-quantity-selector .product__quantity"
  // );
  // const buyButtonsElement = document.querySelector(
  //   ".product-block-buy-buttons"
  // );

  // if (quantityElement && buyButtonsElement) {
  //   buyButtonsElement.appendChild(quantityElement);
  // }
  
  // // ----------- PDP Hide Empty Drop-Down ------------------
  // var accordion_items = document.querySelectorAll("[data-tab-variant]");
  // if (accordion_items.length > 0) {
  //   console.log('emptysaksjaksj');
  //   accordion_items.forEach((tab) => {
  //     const richTextField = tab.querySelector(".metafield-rich_text_field");
  //     const customTab = tab.closest(".custom_tab");
  //     const variantTabDisplay = window.getComputedStyle(tab).display;

  //     if (variantTabDisplay === "block") {
  //       if (richTextField && richTextField.innerHTML.trim() === "") {
  //         customTab.style.display = "none";
  //       }
  //     }
  //   });
  // }

  // const visitCountElement = document.querySelector(".random_visit_count");
  // if (visitCountElement) {
  //   const randomCount = Math.floor(Math.random() * 21) + 10;
  //   visitCountElement.textContent = `${randomCount} Personen`;
  // }

  // const variantIdElement = document.querySelector(
  //   ".product-section-var-b .product-block-buy-buttons [data-product-select]"
  // );
  // if (variantIdElement) {
  //   variantIdElement.addEventListener("change", function () {
  //     const selectedVariantId = variantIdElement.value;
  //     const variantItems = document.querySelectorAll(".variant_bullet_item");
  //     variantItems.forEach(function (item) {
  //       if (item.getAttribute("variant_id") === selectedVariantId) {
  //         item.style.display = "block";
  //       } else {
  //         item.style.display = "none";
  //       }
  //     });
  //   });
  // }

  function adjustTrustbadgeZIndex() {
    const element = document.querySelector(
      'div[data-testid="minimized-trustbadge-floating"]'
    );
    if (!element) return false;

    const grandparent = element.parentElement?.parentElement;
    if (grandparent) {
      grandparent.style.zIndex = "20";
    }
    return true;
  }

  if (!adjustTrustbadgeZIndex()) {
    const trustbadgeObserver = new MutationObserver(function () {
      if (adjustTrustbadgeZIndex()) {
        trustbadgeObserver.disconnect();
      }
    });

    trustbadgeObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(function () {
      trustbadgeObserver.disconnect();
    }, 120000);
  }

  // window.addEventListener('scroll', function() {
  //     const scrollThreshold = parseInt(document.body.getAttribute('show_widget'));
  //     const hiddenElement = document.querySelector('.wa__widget_container');

  //     if (window.scrollY > scrollThreshold) {
  //         hiddenElement.style.display = 'block'; // or use hiddenElement.classList.add('visible') if you have a CSS class for it
  //     } else {
  //         hiddenElement.style.display = 'none'; // or use hiddenElement.classList.remove('visible') if you have a CSS class for it
  //     }
  // });

  var __widgetScrollRAF = null;
  window.addEventListener("scroll", function () {
    if (__widgetScrollRAF) return;
    __widgetScrollRAF = requestAnimationFrame(function () {
      __widgetScrollRAF = null;
      const scrollThreshold =
        parseInt(document.body.getAttribute("show_widget")) || 100;
      const hiddenElement = document.querySelector(".wa__widget_container");

      if (!hiddenElement) return;

      if (window.scrollY > scrollThreshold) {
        hiddenElement.style.display = "block";
      } else {
        hiddenElement.style.display = "none";
      }
    });
  }, { passive: true });

  // ------------------ Cart Upsell ---------------------

  // let variantSelectors = document.querySelectorAll(".upsell_variant_selector");
  // var upsellElement = document.querySelector(".upsell_add_to_cart");
  // var first_id = upsellElement.getAttribute("first_variant");
  // var selected_img = document.querySelector(".cart_upsell_item_image img");

  // var upsell_data = {
  //   id: first_id,
  //   quantity: 1,
  // };

  // function updateVariantID() {
  //   let selectedOptions = [];
  //   variantSelectors.forEach((select) => {
  //     selectedOptions.push(select.value);
  //   });

  //   let selectedVariant = window.variants.find((variant) => {
  //     return variant.options.every(
  //       (option, index) => option === selectedOptions[index]
  //     );
  //   });

  //   if (selectedVariant) {
  //     upsell_data.id = selectedVariant.id;
  //     selected_img.setAttribute("src", selectedVariant.featured_image.src);
  //   }
  // }

  // variantSelectors.forEach((select) => {
  //   console.log('chnaged');
  //   select.addEventListener("change", updateVariantID);
  // });

  // upsellElement.addEventListener("click", function () {
  //   upsellElement.classList.add("btn--loading");
  //   upsellElement.setAttribute("disabled", "disabled");

  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(upsell_data),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       fetch("/cart.js")
  //         .then((response) => response.json())
  //         .then((cart) => {
  //           for (var i = 0; i < cart.item_count; i++) {
  //             if (cart.items[i].id == upsell_data.id) {
  //               document.querySelector(".cart_upsell_main").style.display =
  //                 "none";
  //               break;
  //             }
  //           }
  //           document.dispatchEvent(
  //             new CustomEvent("ajaxProduct:added", {
  //               bubbles: true,
  //             })
  //           );
  //           // setTimeout(function(){
  //           //   var cart_drawer = new theme.CartDrawer
  //           //   cart_drawer.init();
  //           // },500);
  //           // cart_drawer.open();
  //         });
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // });

  // document.addEventListener("cart:updated", function (evt) {
  //   var product_availabel = false;

  //   fetch("/cart.js")
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       for (var i = 0; i < cart.items.length; i++) {
  //         if (cart.items[i].id === upsell_data.id) {
  //           product_availabel = true;
  //           break;
  //         }
  //       }

  //       if (!product_availabel) {
  //         upsellElement.classList.remove("btn--loading");
  //         upsellElement.removeAttribute("disabled");
  //         document.querySelector(".cart_upsell_main").style.display = "block";
  //       }
  //     })
  //     .catch((error) => console.error("Error fetching cart:", error));
  // });
  
});

document.addEventListener('cart:build', function (event) {
  setTimeout(function(){
    const cartItems = document.querySelector('.drawer__scrollable .cart__items');
    if (cartItems) {
      const cartDiscountAttr = cartItems.getAttribute('data-cart-discount');
 
      const discountElement = document.querySelector('.ajaxcartc__discount');
      if (discountElement) {
        discountElement.textContent = '-' + cartDiscountAttr;
      }
    }
  },1000);
});

const SWIPER_CSS_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
const SWIPER_JS_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";

function ensureSwiperAssets() {
  if (window._swiperPromise) return window._swiperPromise;

  window._swiperPromise = new Promise((resolve, reject) => {
    const head = document.head || document.getElementsByTagName("head")[0];

    if (!document.querySelector('link[data-swiper="true"]')) {
      const link = document.createElement("link");
      link.setAttribute("data-swiper", "true");
      link.rel = "preload";
      link.as = "style";
      link.href = SWIPER_CSS_URL;
      link.onload = () => {
        link.rel = "stylesheet";
      };
      link.onerror = reject;
      head.appendChild(link);

      if (!document.querySelector("noscript[data-swiper-noscript]")) {
        const noscript = document.createElement("noscript");
        noscript.setAttribute("data-swiper-noscript", "true");
        noscript.innerHTML = `<link rel="stylesheet" href="${SWIPER_CSS_URL}">`;
        head.appendChild(noscript);
      }
    }

    if (window.Swiper) {
      resolve(window.Swiper);
      return;
    }

    const script = document.createElement("script");
    script.src = SWIPER_JS_URL;
    script.defer = true;
    script.onload = () => resolve(window.Swiper);
    script.onerror = reject;
    head.appendChild(script);
  });

  return window._swiperPromise;
}
window.ensureSwiperAssets = ensureSwiperAssets;

function initProductSliders() {
  const sliders = document.querySelectorAll(".product_item_image_slider");
  if (!sliders.length) return;

  ensureSwiperAssets()
    .then(() => {
      sliders.forEach((element) => {
        const parentContainer = element.closest(".pdp_slider_parent");
        if (!parentContainer) return;
        const swiper = new Swiper(element, {
          scrollbar: {
            el: parentContainer.querySelector(".swiper-scrollbar"),
            hide: false,
          },
          on: {
            slideChange: function () {
              updateNavigationButtons();
            },
          },
        });

        const card_prevButton = parentContainer.querySelector(".card_btn_prev");
        const card_nextButton = parentContainer.querySelector(".card_btn_next");
        card_prevButton?.addEventListener("click", function () {
          swiper.slidePrev();
        });
        card_nextButton?.addEventListener("click", function () {
          swiper.slideNext();
        });
        function updateNavigationButtons() {
          if (card_prevButton) {
            card_prevButton.style.visibility = swiper.isBeginning ? "hidden" : "visible";
          }

          if (card_nextButton) {
            card_nextButton.style.visibility = swiper.isEnd ? "hidden" : "visible";
          }
        }
        updateNavigationButtons();
      });
    })
    .catch((error) => console.error("Failed to load Swiper assets", error));
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initProductSliders, 100);
  });
} else {
  setTimeout(initProductSliders, 100);
}

const new_observer = new MutationObserver(() => {
  const button = document.querySelector(
    "#ReviewsWidget .R-Button.R-Button--md.R-Button--primary.u-marginBottom--none.u-marginTop--md"
  );

  if (button) {
    button.textContent = "Schreibe eine Bewertung";
    new_observer.disconnect();
    clearTimeout(timeoutId);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const reviewsWidget = document.querySelector("#ReviewsWidget");
  if (reviewsWidget) {
    new_observer.observe(reviewsWidget, { childList: true, subtree: true });
  } else {
    new_observer.observe(document.body, { childList: true, subtree: true });
  }
});

const timeoutId = setTimeout(() => {
  new_observer.disconnect();
  console.log(
    "Stopped observing - Review.io empty review element not found within the time limit."
  );
}, 5000);

document.addEventListener('click', function (e) {
  const color_swatch = e.target.closest('.color-swatch-btn');
  if (!color_swatch) return;

  const link = color_swatch.getAttribute('data-variant-link');
  const image = color_swatch.getAttribute('data-variant-image');
  const variant_id = color_swatch.getAttribute('data-variant-id');

  const parent = color_swatch.closest('.grid-product');
  if (!parent) return;

  parent.querySelectorAll('.color-swatch-btn').forEach(btn => {
    btn.classList.remove('active_swatch_btn');
  });

  color_swatch.classList.add('active_swatch_btn');

  // Update all product links
  parent.querySelectorAll('.grid-product__content a').forEach(el => {
    el.setAttribute('href', link);
  });

  // Hide first image
  const first_img = parent.querySelector('.grid_item_first_img');
  if (first_img) {
    first_img.style.visibility = 'hidden';
  }

  const selectedImage =  parent.querySelector(`.swatch-product__color-image`);
  if(selectedImage){
    selectedImage.style.backgroundImage = 'url(' + image + ')';
    selectedImage.classList.add('active_swatch');
  }

});

// ---------------- PDP Variant Bullet Points ----------------
document.addEventListener('variant:change', (e) => {
  const newVariantId = String(e.detail.variant.id);

  document.querySelectorAll('.product-block-bullet_points').forEach(block => {
    const allItems = block.querySelectorAll('.variant_bullet_item');

    allItems.forEach(item => {
      if (item.getAttribute('data-variant-id') === newVariantId) {
        item.classList.remove('hide_points');
      } else {
        item.classList.add('hide_points');
      }
    });
  });
});
// ---------------- End PDP Variant Bullet Points ----------------

// ---------------- Cart Reminder JS -----------------------

document.addEventListener('DOMContentLoaded', function () {

    const cartDrawer = document.querySelector('.js-drawer-open-cart');
    const popupCart_Btns = document.querySelectorAll('.cr--popup__cta');

    var popupContainer = document.querySelector('.cr--cart-popup-container');
    var popup = document.getElementById('cr--cart-popup');
    var overlay = document.getElementById('cr--cart-popup-overlay');
    var closeBtn = document.getElementById('cr--popup-close');

    // 1. Cart is empty (Liquid did not render the popup) → nothing to do.
    if (!popupContainer) return;

    // ── Close helpers ──────────────────────────────────────────────────────

    function closePopup() {
      popup.classList.remove('is-visible');
      // Hide after transition completes (350 ms matches CSS).
      setTimeout(function () {
        popupContainer.style.display = 'none';
        document.documentElement.classList.remove('dom-lockall');
      }, 360);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    // Click on the transparent overlay (outside the card) closes popup.
    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    popupCart_Btns.forEach(el => {
      el.addEventListener('click', () => {
        closePopup();
        setTimeout(()=>{
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: {}, addToCartBtn: null }
          }));
        },500);
      });
    });

    if (sessionStorage.getItem('cr_cart_session')) return;
    if(window.innerWidth < 767){
      sessionStorage.setItem('cr_cart_session', 'true');
      setTimeout(function () {
        popupContainer.style.display = 'block';
        document.documentElement.classList.add('dom-lockall');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            popup.classList.add('is-visible');
          });
        });
      }, 4000);
    }
    else if(window.location.href.includes('/products/')){
      sessionStorage.setItem('cr_cart_session', 'true');
      setTimeout(function () {
        popupContainer.style.display = 'block';
        document.documentElement.classList.add('dom-lockall');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            popup.classList.add('is-visible');
          });
        });
      }, 1000);
    }

});

// ---------------- End Cart Reminder JS -----------------------


// PDP: BuyBox neu konzepieren (Schritt 3) JS
  document.addEventListener('DOMContentLoaded', function() {
    // var randomVisitors = document.querySelector('.random_visitors_main');
    // var productBlock = document.querySelector('.product-block[data-dynamic-variants-enabled]');

    // if (randomVisitors && productBlock) {
    //   randomVisitors.insertAdjacentElement('afterend', productBlock);
    // }

    var span = document.querySelector(".product-block--price .product__policies span");

    if (span) {
      // Remove the strong tag
      var strong = span.querySelector("strong");
      if (strong) strong.remove();

      // Remove the remaining text node
      span.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes("innerhalb")) {
          node.textContent = "";
        }
      });

      // Remove the "|" sign
      span.innerHTML = span.innerHTML.replace("|", "").trim();
    }

    setTimeout(() => {
      const savedCountry = localStorage.getItem('shipping_country');
      const selector = document.querySelector('.cart-shipping-country');
      if (savedCountry && selector) {
        selector.value = savedCountry;
        selector.dispatchEvent(new Event('change'));
      }
      update_cartTotal();
    }, 1500);

  });

// PDP: BuyBox neu konzepieren (Schritt 3) JS

// ------------ Cart - Kostentransparenz ------------

const formatterZero = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  // minimumFractionDigits: 0,
  // maximumFractionDigits: 0
});

window.update_cartTotal = function() {
  let totalShipping = 0;
  let totalPrice = 0;
  const country = localStorage.getItem('shipping_country') || 'Deutschland';

  const dataShipping = document.querySelector('[data-shipping-rate]');
  const dataSum = document.querySelector('[data-endsum]');

  document.querySelectorAll('.drawer__scrollable .cart__item').forEach(item => {
    const category = item.getAttribute('shipping_tag');
    const price = parseInt(item.getAttribute('data-price')) || 1;
    const qty = parseInt(item.getAttribute('data-qty')) || 1;

    const shipprice = allShippingData?.[category]?.[country] || 0;

    totalShipping += shipprice * qty;
    totalPrice += price * qty;
  });

  console.log('totalShipping ',totalShipping);

  if(totalShipping == 0){
    console.log('if ',totalShipping, dataShipping);
    dataShipping.innerHTML = '<div style="color:#92BF20;">Gratis</div>';
  }else{
    console.log('else ',totalShipping);
    dataShipping.innerHTML = formatterZero.format(totalShipping);
  }

  const finalTotal = (totalPrice + (totalShipping * 100)) / 100;
  dataSum.innerHTML = formatterZero.format(finalTotal);
}

document.addEventListener('change', function(event) { 
  const countrySelector = event.target.closest('.cart-shipping-country');

  if (countrySelector) {
    const country = countrySelector.value;
    console.log(country);
    localStorage.setItem('shipping_country', country);
    update_cartTotal();
  }
});

// ------------ Cart - Kostentransparenz ------------
/* =========================================================
   KI-Hinweis unten links im großen Produktbild
   ========================================================= */

(function () {
  var badge = null;
  var modal = null;
  var activeViewport = null;
  var lastFocusedElement = null;

  function findMainViewport() {
    var slider = document.querySelector(
      'clever-slider[id^="ProductPhotosSlider-"]'
    );

    if (!slider) {
      return null;
    }

    return slider.querySelector(':scope > .slider_viewport');
  }

  function createModal() {
    var existingModal = document.querySelector('.ai-modal');

    if (existingModal) {
      return existingModal;
    }

    var newModal = document.createElement('div');

    newModal.className = 'ai-modal';
    newModal.setAttribute('role', 'dialog');
    newModal.setAttribute('aria-modal', 'true');
    newModal.setAttribute('aria-hidden', 'true');
    newModal.setAttribute(
      'aria-labelledby',
      'ai-modal-heading'
    );

    newModal.innerHTML =
      '<div class="ai-modal__box">' +
        '<div class="ai-modal__head" id="ai-modal-heading">' +
          'Hinweis zu den Produktbildern' +
        '</div>' +
        '<button ' +
          'type="button" ' +
          'class="ai-modal__close" ' +
          'aria-label="Schließen">' +
          '\u00D7' +
        '</button>' +
        '<p class="ai-modal__text">' +
          'Einige Produktbilder wurden teilweise mit KI erstellt.' +
          '<br><br>' +
          '<b>Aber keine Sorge:</b> Das dargestellte Produkt ' +
          'entspricht dem echten Artikel.' +
        '</p>' +
      '</div>';

    document.body.appendChild(newModal);

    newModal.addEventListener('click', function (event) {
      if (
        event.target === newModal ||
        event.target.classList.contains('ai-modal__close')
      ) {
        closeModal();
      }
    });

    return newModal;
  }

  function createBadge() {
    var existingBadge = document.querySelector('.ai-badge');

    if (existingBadge) {
      return existingBadge;
    }

    var newBadge = document.createElement('button');

    newBadge.type = 'button';
    newBadge.className = 'ai-badge';

    newBadge.setAttribute(
      'aria-label',
      'Hinweis zu den Produktbildern öffnen'
    );

    newBadge.innerHTML =
      '<span>KI Hinweis</span>' +
      '<span class="ai-badge__i" aria-hidden="true">i</span>';

    newBadge.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openModal();
    });

    return newBadge;
  }

  function openModal() {
    if (!modal) {
      return;
    }

    lastFocusedElement = document.activeElement;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    var closeButton = modal.querySelector('.ai-modal__close');

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus === 'function'
    ) {
      lastFocusedElement.focus();
    }
  }

  function placeBadge() {
    var viewport = findMainViewport();

    if (!viewport || !badge) {
      return false;
    }

    if (
      activeViewport &&
      activeViewport !== viewport
    ) {
      activeViewport.classList.remove('ai-gallery-wrap');
    }

    activeViewport = viewport;
    activeViewport.classList.add('ai-gallery-wrap');

    if (badge.parentElement !== activeViewport) {
      activeViewport.appendChild(badge);
    }
  
    return true;
  }

  function init() {
    modal = createModal();
    badge = createBadge();

    placeBadge();

    /*
     * Mehrere Versuche für verzögert geladene Galerien.
     */
    var attempts = 0;

    var interval = window.setInterval(function () {
      attempts++;

      if (placeBadge() || attempts >= 40) {
        window.clearInterval(interval);
      }
    }, 300);

    /*
     * Setzt den Badge erneut ein, falls Shopify die
     * Produktgalerie dynamisch austauscht.
     */
    var pageObserver = new MutationObserver(function () {
      window.requestAnimationFrame(placeBadge);
    });

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    /*
     * Unterstützung für den Shopify-Theme-Editor.
     */
    document.addEventListener(
      'shopify:section:load',
      placeBadge
    );

    window.addEventListener('resize', placeBadge);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
/* =========================================================
   Übersetzungen für KI-Hinweis und KI-Popup
   Grundlage: <html lang="de">, <html lang="fr"> oder
   <html lang="nl">
   ========================================================= */

(function () {
  var translations = {
    de: {
      badge: 'KI Hinweis',
      badgeAria: 'Hinweis zu den Produktbildern öffnen',
      heading: 'Hinweis zu den Produktbildern',
      close: 'Schließen',
      text:
        'Einige Produktbilder wurden teilweise mit KI erstellt.' +
        '<br><br>' +
        '<b>Aber keine Sorge:</b> Das dargestellte Produkt ' +
        'entspricht dem echten Artikel.'
    },

    fr: {
      badge: 'Info IA',
      badgeAria:
        'Ouvrir les informations sur les images du produit',
      heading: 'Informations sur les images du produit',
      close: 'Fermer',
      text:
        'Certaines images du produit ont été en partie créées ' +
        'à l’aide de l’IA.' +
        '<br><br>' +
        '<b>Mais rassurez-vous :</b> le produit présenté ' +
        'correspond à l’article réel.'
    },

    nl: {
      badge: 'AI-info',
      badgeAria:
        'Informatie over de productafbeeldingen openen',
      heading: 'Informatie over de productafbeeldingen',
      close: 'Sluiten',
      text:
        'Sommige productafbeeldingen zijn gedeeltelijk met ' +
        'AI gemaakt.' +
        '<br><br>' +
        '<b>Maar geen zorgen:</b> het afgebeelde product ' +
        'komt overeen met het echte artikel.'
    }
  };

  var updateScheduled = false;

  function getLanguage() {
    var language =
      document.documentElement.getAttribute('lang') || 'de';

    language = language.toLowerCase();

    if (language.indexOf('fr') === 0) {
      return 'fr';
    }

    if (language.indexOf('nl') === 0) {
      return 'nl';
    }

    return 'de';
  }

  function translateBadges(language, content) {
    var badges = document.querySelectorAll('.ai-badge');

    badges.forEach(function (badge) {
      if (badge.dataset.aiLanguage === language) {
        return;
      }

      badge.dataset.aiLanguage = language;

      var badgeText = badge.querySelector('span:first-child');

      if (badgeText) {
        badgeText.textContent = content.badge;
      }

      badge.setAttribute(
        'aria-label',
        content.badgeAria
      );
    });
  }

  function translateModals(language, content) {
    var modals = document.querySelectorAll('.ai-modal');

    modals.forEach(function (modal) {
      if (modal.dataset.aiLanguage === language) {
        return;
      }

      modal.dataset.aiLanguage = language;

      var heading = modal.querySelector('.ai-modal__head');
      var text = modal.querySelector('.ai-modal__text');
      var closeButton =
        modal.querySelector('.ai-modal__close');

      if (heading) {
        heading.textContent = content.heading;
      }

      if (text) {
        text.innerHTML = content.text;
      }

      if (closeButton) {
        closeButton.setAttribute(
          'aria-label',
          content.close
        );
      }
    });
  }

  function applyTranslations() {
    var language = getLanguage();
    var content =
      translations[language] || translations.de;

    translateBadges(language, content);
    translateModals(language, content);
  }

  function scheduleTranslation() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    window.requestAnimationFrame(function () {
      updateScheduled = false;
      applyTranslations();
    });
  }

  /*
   * Sofort übersetzen, falls Badge und Popup bereits existieren.
   */
  applyTranslations();

  /*
   * Erfasst später erzeugte Badges und Popups sowie einen
   * Sprachwechsel ohne vollständiges Neuladen der Seite.
   */
  var translationObserver = new MutationObserver(
    scheduleTranslation
  );

  translationObserver.observe(
    document.documentElement,
    {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['lang']
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyTranslations
    );
  }
})();
